import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { checkArray } from '../../../../Components/helper';

const object = {
  InActive: 'Draft',
  canceled: 'Cancelled',
  revised: 'Revised',
  Approve: 'Confirmed',
  Reject: 'Rejected',
  Delivered: 'Delivered',
  Active: 'Active',
  'Cancel Request': 'Cancel Request',
};

export function PoLogList() {
  const {
    purchaseOrderData: { poLogList },
  } = useSelector((reduxState) => reduxState);
  const { t } = useTranslation('common');

  return (
    <div className="table-responsive">
      <table className="table custom-table font-13 mb-5">
        <thead>
          <tr>
            <th>
              <span className="cursor-pointer">{t('PURCHASE_ORDER_LOG.PO_LOG_LIST.PO_NUMBER')}</span>
            </th>
            <th>
              <span className="cursor-pointer">{t('PURCHASE_ORDER_LOG.PO_LOG_LIST.PO_ACTION_DATE_TIME')}</span>
            </th>
            <th>
              <span className="cursor-pointer">{t('PURCHASE_ORDER_LOG.PO_LOG_LIST.PO_STATUS')}</span>
            </th>
            <th>
              <span className="cursor-pointer">{t('PURCHASE_ORDER_LOG.PO_LOG_LIST.SUPPLIER_COMMENT')}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {checkArray(poLogList)
            ? poLogList.map((log, i) => {
                return (
                  <tr key={i}>
                    <td>{log?.poOrderNo || '--'}</td>
                    <td>{log?.createdAt ? moment(log?.createdAt).format('DD-MMM-YYYY HH:mm') : '--'}</td>
                    <td>{object[log?.status] || '--'}</td>
                    <td>{log?.comment || '--'}</td>
                  </tr>
                );
              })
            : t('PURCHASE_ORDER_LOG.PO_LOG_LIST.NO_RECORDS')}
        </tbody>
      </table>
    </div>
  );
}

export default PoLogList;
